/* eslint-disable max-len */
import { configureStore } from "@reduxjs/toolkit"
import authSlice from "../pages/auth/authSlice"
import commonSlice from "./commonSlice"
import adminCorporateSlice from "../pages/ManageAdminAndCoporateUser/adminCorporateSlice"
import { persistReducer,persistStore } from "redux-persist"
import storage from 'localforage'
import storageSession from 'redux-persist/lib/storage/session'; // For sessionStorage
import systemConfigSlice from "./systemConfigSlice"
import MultiselectRows from "./MultiselectRows"
import observersSlice from "../pages/ManageOrganizations/observersSlice"
import { usersList } from "../features/apiSlice"
import usersSlice from "../pages/ManageOrganizations/usersSlice"
import MultiselectRowsConditionally from "./MultiselectRowsConditionally"
import monitorsSlice from "../pages/ManageOrganizations/monitorsSlice"
import subdivisionSlice from "../pages/ManageAdminAndCoporateUser/subdivisionSlice"
import apiMiddleware from "./SystemConfigCallMiddleWare"
import { getDefaultMiddleware } from "@reduxjs/toolkit"
import wellnessFilterSlice from "./wellnessFilterSlice"
import wellnessFilterUserSlice from "./wellnessFilterUserSlice"
import wellnessFilterOrganizationSlice from "./wellnessFilterOrganizationSlice"
import wellnessFilterProviderSlice from "./wellnessFilterProviderSlice"
import providersSlice from "../pages/ManageOrganizations/providersSlice"
import deviceSearchSlice from './deviceSearchSlice'
import deviceTemplateSearchSlice from './deviceTemplateSearchSlice'
import providerSearchSlice from './providerSearchSlice'
import observerSearchSlice from './observerSearchSlice'
import patientSearchSlice from './patientSearchSlice'
import organizationSearchSlice from './organizationSearchSlice'
import deviceAlertSearchSlice from './deviceAlertReportSearchSlice'
import accessLogSearchSlice from './accessLogSearchSlice'
import deviceAlertDashboardSearchSlice from './deviceAlertDashboardSlice'
import dashboardSearchSlice from './dashboardSearchSlice'
import wellnessReportSearchSlice from './wellnessReportSearchSlice'

const persistConfig = {
    key: 'root',
    storage,
};

const deviceSearchPersistConfig = {
    key: 'deviceSearchData',
    storage,
};

const deviceTemplateSearchPersistConfig = {
    key: 'deviceTemplateSearchData',
    storage,
};

const providerSearchPersistConfig = {
    key: 'providerSearchData',
    storage,
};

const observerSearchPersistConfig = {
    key: 'observerSearchData',
    storage,
};

const patientSearchPersistConfig = {
    key: 'patientSearchData',
    storage,
};

const organizationSearchPersistConfig = {
    key: 'organizationSearchData',
    storage,
};

const deviceAlertSearchPersistConfig = {
    key: 'deviceAlertSearchData',
    storage,
};

const accessLogSearchPersistConfig = {
    key: 'accessLogSearchData',
    storage,
};

const deviceAlertDashboardSearchPersistConfig = {
    key: 'deviceAlertDashboardSearchData',
    storage,
};

const DashboardSearchPersistConfig = {
    key: 'DashboardSearchData',
    storage,
};
const wellnessReportPersistConfig = {
    key: 'WellnessReportSearchData',
    storage,
};

// Apply persistReducer to each slice separately
// Apply persistReducer to each slice separately with its own configuration
const persistedReducer = persistReducer(persistConfig, systemConfigSlice);
const persistedDeviceSearchReducer = persistReducer(deviceSearchPersistConfig, deviceSearchSlice);
const persistedDeviceTemplateSearchReducer = persistReducer(deviceTemplateSearchPersistConfig, deviceTemplateSearchSlice);
const persistedProviderSearchReducer = persistReducer(providerSearchPersistConfig, providerSearchSlice);
const persistedObserverSearchReducer = persistReducer(observerSearchPersistConfig, observerSearchSlice);
const persistedPatientSearchReducer = persistReducer(patientSearchPersistConfig, patientSearchSlice);
const persistedOrganizationSearchReducer = persistReducer(organizationSearchPersistConfig, organizationSearchSlice);
const persistedDeviceAlertSearchReducer = persistReducer(deviceAlertSearchPersistConfig, deviceAlertSearchSlice);
const persistedWellnesReportSearchReducer = persistReducer(wellnessReportPersistConfig, wellnessReportSearchSlice);

const persistedAccessLogSearchReducer = persistReducer(accessLogSearchPersistConfig, accessLogSearchSlice);
const persistedDeviceAlertDashboardSearchReducer = persistReducer(deviceAlertDashboardSearchPersistConfig, deviceAlertDashboardSearchSlice);const persistedDashboardSearchReducer = persistReducer(DashboardSearchPersistConfig, dashboardSearchSlice);


const middleware = [...getDefaultMiddleware(), apiMiddleware,usersList.middleware];
export const store = configureStore({
    reducer: {
        [usersList.reducerPath]:usersList.reducer,
        auth: authSlice,
        commonData:commonSlice,
        systemConfigData: persistedReducer, // Persisted reducer for system config
        deviceSearchData: persistedDeviceSearchReducer, 
        deviceTemplateSearchData: persistedDeviceTemplateSearchReducer,
        providerSearchData:persistedProviderSearchReducer,
        observerSearchData: persistedObserverSearchReducer,
        patientSearchData: persistedPatientSearchReducer,
        organizationSearchData: persistedOrganizationSearchReducer,
        deviceAlertSearchData: persistedDeviceAlertSearchReducer,
        accessLogSearchData: persistedAccessLogSearchReducer,
        DashboardSearchData: persistedDashboardSearchReducer,
        adminCorporateSlice:adminCorporateSlice,
        MultiSelectSlice:MultiselectRows, 
        userSelect:usersSlice,
        observersSelect:observersSlice,
        monitorsSelect:monitorsSlice,
        providersSelect:providersSlice,
        subdivSelect:subdivisionSlice,
        MultiSelectSliceConditionally: MultiselectRowsConditionally,
        filterSelect:wellnessFilterSlice,
        filterUserNameSelect:wellnessFilterUserSlice,
        filterOrgNameSelect:wellnessFilterOrganizationSlice,
        filterProviderNameSelect:wellnessFilterProviderSlice,
        deviceAlertDashboardSearchData: persistedDeviceAlertDashboardSearchReducer,
        WellnessReportSearchData:persistedWellnesReportSearchReducer,

    },
    // middleware:(getDefaultMiddleware)=>
    //     getDefaultMiddleware().concat(usersList.middleware),
    middleware:middleware,
   
})


export const persistor = persistStore(store);